import { i18nL10nSelectors } from '@/store/i18nL10n'
import { searchSelectors } from '@/store/search'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

export const ANALYTICS_EVENTS = {
  PUBLICATION_VIEW: 'publication_view',
  WEBVIEW_OPEN: 'webview_open',
  OFFLINE_SAVE: 'offline_save',
  OFFLINE_REMOVE: 'offline_remove'
}

export const useAnalytics = () => {
  const locale = useSelector(i18nL10nSelectors.selectLocale)
  const brand = useSelector(searchSelectors.selectBrand)

  const track = useCallback(
    (action, params = {}) => {
      if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
      if (!Object.values(ANALYTICS_EVENTS).includes(action)) {
        console.warn(`Action "${action}" is not available for tracking.`)
      }
      window.gtag('event', action, { ...params, locale, brand })
    },
    [locale, brand]
  )

  return {
    enabled: typeof window !== 'undefined' && typeof window.gtag === 'function',
    track,
    params: {
      brand,
      locale
    }
  }
}
